<template>
  <div>
    <v-layout row wrap>
      <v-flex>
        <section>
          <!-- <v-img
            width="100%"
            height="100vh"
            alt="diskominfo"
            class="px-8"
            gradient="to right, #a20000d1, #000000a6"
            src="https://klatenkab.go.id/wp-content/uploads/2016/12/Candi-Prambanan.jpg"> -->
            <v-card flat style="height: 100vh;">
              <v-card-text style="height: 100%;" class="pa-0">
                <v-row 
                  align="center" 
                  justify="center"
                  style="height: 100%;">
                  <v-col 
                    cols="12"
                    class="py-0"
                    md="7">
                    <v-img
                      width="100%"
                      height="100vh"
                      alt="diskominfo"
                      class="px-8"
                      gradient="to right, #a20000d1, #000000a6"
                      src="https://klatenkab.go.id/wp-content/uploads/2016/12/Candi-Prambanan.jpg">
                    </v-img>
                  </v-col>
                  <v-col 
                    cols="12"
                    md="5"
                    style="height: 100%; display: flex; align-items: center; justify-content: center;">
                    <v-card
                      flat
                      style="width: 500px;">
                      <div>
                        <v-card
                          flat
                          color="#FFFFFFB2"
                          class="border-radius">
                          <v-card-text
                            class="pa-0">
                            <div
                              class="mb-6">
                              <div
                                class="fs-30 black_one font-weight-bold black--text mb-12">
                                Masuk
                              </div>
                            </div>
      
                            <ValidationObserver 
                              ref="observer">
                              <v-form class="text-left mb-0">
                                <div class="fs-14 mb-1 black_two">
                                  Email
                                </div>
                                <ValidationProvider 
                                  name="Email" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <v-text-field
                                    v-on:keyup.enter="save"
                                    class="no_box"
                                    outlined
                                    dense
                                    :color="set_color"
                                    style="border-radius: 4px;"
                                    placeholder="Masukan email yang telah didaftarkan"
      
                                    vv-uppercase
      
                                    v-model="form.username"
                                    :error-messages="errors"
                                    required>
                                  </v-text-field>
                                </ValidationProvider>
      
                                <div class="fs-14 mb-1 black_two">
                                  Kata Sandi
                                </div>
                                <ValidationProvider 
                                  name="password" 
                                  rules="required|min:5|max:30" 
                                  v-slot="{ errors }">
                                  <v-text-field
                                    v-on:keyup.enter="save"
                                    class="no_box"
                                    outlined
                                    dense
                                    :color="set_color"
                                    style="border-radius: 4px;"
                                    placeholder="Masukan kata sandi"
                                    :type="show ? 'text' : 'password'"
                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="show = !show"
                                    :counter="30"
      
                                    vv-uppercase
                                    
                                    v-model="form.password"
                                    :error-messages="errors"
                                    required>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-form>
                            </ValidationObserver>
      
                            <div 
                              class="text-left mb-6">
                              <div v-if="message.error.length > 0"
                                class="text-left my-4">
                                <div
                                  class="error--text d-flex align-start">
                                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                                  
                                  <span
                                    class="ml-1">
                                    {{ message.error }}
                                  </span>
                                </div>
                              </div>
      
                              <!-- <div class="blue_one fs-14 text-right mt-1 mb-5" style="font-weight: 600;">
                                <span class="cursor-pointer">Lupa Kata Sandi</span>
                              </div> -->

                              <!-- <v-btn
                                :disabled="process.form"
                                :loading="process.form"
                                @click="save()"
                                block
                                :color="set_color"
                                width="170"
                                height="40"
                                elevation="0"
                                style="border-radius: 6px;"
                                class="title font-weight-bold white--text text-capitalize">
                                Masuk
                              </v-btn> -->
      
                              <v-btn
                                :disabled="process.form"
                                :loading="process.form"
                                @click="recaptcha()"
                                block
                                :color="set_color"
                                width="170"
                                height="40"
                                elevation="0"
                                style="border-radius: 6px;"
                                class="title font-weight-bold white--text text-capitalize">
                                Masuk
                              </v-btn>

                              <!-- <v-btn @click="recaptcha">Execute recaptcha</v-btn> -->
      
                              <!-- <div class="text-center fs-14 my-10">
                                <span class="black_two">Belum punya akun? </span>
                                <span class="blue_one cursor-pointer" @click="toRegister()">Daftar</span>
                              </div> -->
                            </div>
                          </v-card-text>
                        </v-card>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          <!-- </v-img> -->
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        captcha: false,
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetch()
      // setTimeout(()=>{
      //   const recaptcha = this.$recaptchaInstance
      //   recaptcha.showBadge()
      // },5000)
    },
    methods: {
      async fetch () {
        await get('sites/config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[12].color = JSON.parse(res.results.data[12].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[12]))

            this.$store.commit("setCompany", res.results.data[12])
            
            if (res.results.data[12].color.length > 0) {
              res.results.data[12].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)
                  // TokenService.saveColor('#a20000')

                  this.$store.commit("setColor", obj.hex)
                  // this.$store.commit("setColor", '#a20000')
                }
              })
            } else {
              TokenService.saveColor('#a20000')

              this.$store.commit("setColor", '#a20000')
            }
          }
        })
      },

      async recaptcha() {
        this.message.error = ''
        // (optional) Wait until recaptcha has been loaded.
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true
          await this.$recaptchaLoaded()

          // Execute reCAPTCHA with action "login".
          const token = await this.$recaptcha('login')

          // let formData = new FormData()
          //       formData.append('secret', '6LdXR4oqAAAAAL5KjnCLuncKPczuNlUCSsGgN7Gl')
          //       formData.append('response', '03AFcWeA5W_bPdL1iPsBMELSrK24b91zCMYrK30Pko2P2rbwDy0cfubF9qVXxKRBm-bgxBMmdvHjmPVlvOjZcorbWk_1CsVkSCL_r47WwINJOvXo-nH0ndzCLKgA1UG2W0b_XR8mSkbnF-gu5Cmg_Ahfofcq2YCbuaGvZJZSTO57MJktMsZo5g3-ZkRyqO7O-WozMhLzZ9xiqPI-Av7uOTmjyTHrXlmCxL2d8tXZHpKzcu3pnLx7tfU6858tRaDcmfThwGnf-ll5Qs4ha0OsWb5Vq6Lgwu63RgqWi4FYNVNktM2jD9Z4IzpDokFNCN16qH2bGxofr9g1-wx7uG4OWLwN_Lniy84if5Tm1YhRUCRCQWE7cRNCurKg_QpmxsHo2hj0weokq70eLVeOnzqgqqKc3eMMiDW7txv3c_Fa1KX4Um2zGDoXrDwJey5j1Aho_5h0ApxaVql3bRJ8IVRPpPBhOxb8VWQD90cYanbu6YpIyEbT6QzSGAK3JRC8axsyLbuDF9OFwgGnJagVKolwKIQUPRW6IBJjzhDhwr4rX_UvPX4ext4jp8PtyyfCwaQEjGzZcdHxOkDhupQcnsY7uuGkGrVmObo_GeMS2RCz2pFsbUDss9qrrENl1cDe87WaKkKSQ2xPbRJIV5ertFY0CJnwzD6sM9xrZmX7PlWwyIZDuVwqTOHNeTHpDAnKsI_tNxPUAgxo93BZDsaloQPcYQbc_mr2NxKi4a-y7ZmxmaXMUVR-VDrQX_NvTC7cgHqxcpGvMmz6eSD8YH3lLPn4jMMZA3SnIRvH1Uwx_Ix2BPRKFNQESZVsVyuslKOlRmlnskx7zCAqi_rhbvqkum2ZefCXOwIGT9Lv9vWtq6fDr9e_X-UxbUVV3QEGJK11sEfdF1xr6oSX_HDofNSfNWYd9DhbULocYV0k3L8PE5zUueQfvlwZe6pLn8rEoDNnXtbsiwfgEZfLM9IhtOBDyVeFjHjNgxclHg6VV8SDxYuuYh5yoT6xNWzg_KDZhxxXQrj8BD_a66EimgJKe84k_dCufwdAyDDwg9H7HPIx2OGnk3AhpeWSnT8bHH0Gu_Pk1A5csxHoxAvOcH8_J7k80nePFMoPu82vY74Emtd7WdcTkJSfGhwGDCCDLHBL2UpyoJtakrJE36OtCgnCOxNek8qTZnuyIIHJuR4taqr2KdAmCnAefngo7CSTzQIKR3-b-vNzTpe4_KXxBl7MlSxM2kh4W7_BeBdYrYRz7Zc_4CvP_Q050ebnOuBw6GTPOOKf0g3sSdqUptoAYE4JmYJfaPmCru57WpDJkAM3vT4-C9jXTOqAm5q_-vW5ABpIPvMMFlp5mROShue-XUyQxrVy6ZV_vftT8O3A3lroia5q8Z6moj46zV5BLBMsqZhOVghuUV_JOJnGt-z-FDK7xF8-Rxa2LnYCyLCAMhCT6Y3jkDmvAGxw0yn7sC6cHH9o9ePRcxF3P3XB0stz_e3m10CnL-oxO-dhVwzqhlFvJt4LX67Aepzh_rul084oW0iBFSVHOjj6OqWGiAgsaFMGTda0M7iGkTX2eEE1uahNsuO3jWBIQyoB8a-bT6mi5dt8h8U9WNeuiCNsoxNNPCKtaSk8sqJallrtYLyIvdssYO4iRXewyEaPo5V6O1J2yYEQQJ8wI3tO3Cead-wsKGbtWx7cclyL5vz9mspPmMNoPDmnPBvUhauhlOyBt7gwNdFJnpk3p8nsMsnxMqGf-2FUjJaWjdIPb7C7Ikf-ywL0FQX0_PyDM7KGawS-Y6gOz1P8Ssol3MgH6xQwlynufpcIiBdhl0iwJhTkS1ofLGb2dUHywYi1ae5WbSEhXBy6umVgGBCRZ12WdjmsPKy-CUIegjpxaqpyiIyS7Kv5x0h41MMHajXJ3wxffrQSfWWilNr8TFPZfI4AHi3bAnNz36_EP4')

          //   await fetch(`https://www.google.com/recaptcha/api/siteverify`, {
          //     method: 'POST',
          //     mode: 'no-cors',
          //     body: formData
          //   })
          //   .then(res => res.json())
          //   .then(response => {
          //     console.log(response)
          //   })

          let params = {
            secret: '6LdXR4oqAAAAAL5KjnCLuncKPczuNlUCSsGgN7Gl',
            token: token
          }

          await axios({
            url: `${process.env.VUE_APP_API_URL}admin/auth/validate`,
            method: 'POST',
            data: params,
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          }).then((response) => {
            let res = response
            this.captcha = res.data.results.data.success

            if (this.captcha) {
              this.save()
            } else {
              this.process.form = false
              this.message.error = 'Kami menduga adanya aktivitas otomatis. Harap coba lagi untuk mengonfirmasi bahwa Anda adalah pengguna asli'
            }
            
          })
        }

        // Do stuff with the received token.
      },


      async save () {
        this.message.error = ''

        
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              let user = res.results.data

              let menu = [
                {
                  title: 'Dashboard',
                  icon: require('@/assets/icon/dashboard.png'),
                  link: '/dashboard',
                  active: true,
                  sub_menu: []
                },
                {
                  title: 'Kategori Layanan',
                  icon: require('@/assets/icon/setting-layanan.png'),
                  link: '/layanan-category',
                  active: false,
                  sub_menu: [
                    // {
                    //   title: 'Kategori Layanan',
                    //   icon: require('@/assets/icon/information.png'),
                    //   link: '/layanan-category',
                    //   active: false
                    // },
                    // {
                    //   title: 'Data Layanan',
                    //   icon: require('@/assets/icon/information.png'),
                    //   link: '/layanan',
                    //   active: false
                    // }
                  ]
                },
                {
                  title: 'Layanan',
                  icon: require('@/assets/icon/information.png'),
                  link: '/layanan',
                  active: false,
                  sub_menu: [
                    // {
                    //   title: 'Kategori Layanan',
                    //   icon: require('@/assets/icon/information.png'),
                    //   link: '/layanan-category',
                    //   active: false
                    // },
                    // {
                    //   title: 'Data Layanan',
                    //   icon: require('@/assets/icon/information.png'),
                    //   link: '/layanan',
                    //   active: false
                    // }
                  ]
                },
                {
                  title: 'Kategori Pariwisata',
                  icon: require('@/assets/icon/setting-pariwisata.png'),
                  link: '/pariwisata-category',
                  active: false,
                  sub_menu: [
                    // {
                    //   title: 'Kategori Pariwisata',
                    //   icon: require('@/assets/icon/summer.png'),
                    //   link: '/pariwisata/category',
                    //   active: false
                    // },
                    // {
                    //   title: 'Data Pariwisata',
                    //   icon: require('@/assets/icon/summer.png'),
                    //   link: '/pariwisata',
                    //   active: false
                    // }
                  ]
                },
                {
                  title: 'Pariwisata',
                  icon: require('@/assets/icon/summer.png'),
                  link: '/pariwisata',
                  active: false,
                  sub_menu: [
                    // {
                    //   title: 'Kategori Pariwisata',
                    //   icon: require('@/assets/icon/summer.png'),
                    //   link: '/pariwisata/category',
                    //   active: false
                    // },
                    // {
                    //   title: 'Data Pariwisata',
                    //   icon: require('@/assets/icon/summer.png'),
                    //   link: '/pariwisata',
                    //   active: false
                    // }
                  ]
                },
                {
                  title: 'Kategori Berita',
                  icon: require('@/assets/icon/setting-news.png'),
                  link: '/berita-category',
                  active: false,
                  sub_menu: [
                    // {
                    //   title: 'Kategori Berita',
                    //   icon: require('@/assets/icon/media.png'),
                    //   link: '/berita/category',
                    //   active: false
                    // },
                    // {
                    //   title: 'Data Berita',
                    //   icon: require('@/assets/icon/media.png'),
                    //   link: '/berita',
                    //   active: false
                    // }
                  ]
                },
                {
                  title: 'Berita',
                  icon: require('@/assets/icon/media.png'),
                  link: '/berita',
                  active: false,
                  sub_menu: [
                    // {
                    //   title: 'Kategori Berita',
                    //   icon: require('@/assets/icon/media.png'),
                    //   link: '/berita/category',
                    //   active: false
                    // },
                    // {
                    //   title: 'Data Berita',
                    //   icon: require('@/assets/icon/media.png'),
                    //   link: '/berita',
                    //   active: false
                    // }
                  ]
                },
                {
                  title: 'Pengumuman',
                  icon: require('@/assets/icon/loudspeaker.png'),
                  link: '/pengumuman',
                  active: false,
                  sub_menu: []
                },
                {
                  title: 'Agenda',
                  icon: require('@/assets/icon/timetable.png'),
                  link: '/agenda',
                  active: false,
                  sub_menu: []
                },
                // {
                //   title: 'OPD, kecamatan & desa',
                //   icon: require('@/assets/icon/struktur.png'),
                //   link: '/structure',
                //   active: false,
                //   sub_menu: []
                // },
                {
                  title: 'Daftar Pejabat',
                  icon: require('@/assets/icon/man.png'),
                  link: '/daftar-pejabat',
                  active: false,
                  sub_menu: []
                },
                // {
                //   title: 'Profil Pejabat',
                //   icon: require('@/assets/icon/workers.png'),
                //   link: '/profil-pejabat',
                //   active: true,
                //   sub_menu: []
                // },
                {
                  title: 'Dokumen',
                  icon: require('@/assets/icon/sheet.png'),
                  link: '/document',
                  active: false,
                  sub_menu: []
                },
                // {
                //   title: 'Unit',
                //   icon: require('@/assets/icon/struktur.png'),
                //   link: '/unit',
                //   active: false,
                //   sub_menu: [
                //     {
                //       title: 'Struktur Organisasi',
                //       link: '/unit/structure',
                //       active: false
                //     },
                //     {
                //       title: 'Data Unit / Divisi',
                //       link: '/unit/division',
                //       active: false
                //     },
                //     {
                //       title: 'Aturan Organisasi',
                //       link: '/unit/rule',
                //       active: false
                //     }
                //   ]
                // },
                {
                  title: 'User',
                  icon: require('@/assets/icon/man.png'),
                  link: '/user',
                  active: true,
                  sub_menu: []
                },
                {
                  title: 'Galeri',
                  icon: require('@/assets/icon/wallpaper.png'),
                  link: '/galeri',
                  active: true,
                  sub_menu: [
                    // {
                    //   title: 'Kategori Galeri',
                    //   link: '/galeri/category',
                    //   active: false
                    // },
                    // {
                    //   title: 'Data Galeri',
                    //   link: '/galeri',
                    //   active: false
                    // }
                  ]
                },
                {
                  title: 'Polling',
                  icon: require('@/assets/icon/rating.png'),
                  link: '/voting',
                  active: true,
                  sub_menu: []
                },
                {
                  title: 'Menu Dinamis',
                  icon: require('@/assets/icon/upload_folder.png'),
                  link: '/menu',
                  active: true,
                  sub_menu: []
                },
                {
                  title: 'Setting',
                  icon: require('@/assets/icon/setting.png'),
                  link: '/setting',
                  active: false,
                  sub_menu: [
                    {
                      title: 'Perusahaan',
                      icon: require('@/assets/icon/company.png'),
                      link: '/setting/company',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Banner',
                      icon: require('@/assets/icon/slider.png'),
                      link: '/setting/banner',
                      active: false,
                      sub_menu: []
                    },
                    {
                      title: 'Dialog Promosi',
                      icon: require('@/assets/icon/pop-up.png'),
                      link: '/setting/promo',
                      active: false,
                      sub_menu: []
                    }
                  ]
                }
              ]

              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu)
              )

              TokenService.saveReload(false)

              window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>